import { useNavigate, Link } from "react-router-dom";
import SEO from "../../components/SEO";
import useUser, { isUserDoctor, isUserClient } from "../../hooks/User";
import { ROUTES } from "../../routes";
import "./about.css";
import { useEffect, useState } from "react";

import Ivan   from "../../Assets/Team Members/Иван.jpg";
import Aydar  from "../../Assets/Team Members/Айдар.jpeg";
import Danila from '../../Assets/Team Members/Данила.jpg';
import Ruslan from "../../Assets/Team Members/Руслан.jpg";
import Senya  from "../../Assets/Team Members/Арсений.jpg";

// Logo icon component
function LogoIcon() {
    return (
        <svg 
            version="1.0" 
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 294 295"
            preserveAspectRatio="xMidYMid slice"
            fill="#2f6fed"
        >
            <g transform="translate(0.000000,295.000000) scale(0.100000,-0.100000)"
               fill="#2f6fed"
               stroke="none">
                <path d="M1281 2855 c-215 -47 -403 -162 -535 -327 -294 -367 -266 -893 63
-1227 166 -168 402 -271 620 -271 l65 0 -39 -41 c-213 -220 -572 -258 -836
-87 -191 122 -309 340 -309 568 0 41 5 95 11 120 8 35 6 63 -7 130 -11 54 -18
135 -18 222 -1 131 -2 136 -19 120 -31 -27 -105 -145 -137 -217 -60 -133 -75
-213 -74 -385 1 -138 4 -165 27 -243 48 -155 117 -276 221 -385 333 -349 866
-385 1246 -85 196 155 314 377 344 648 l11 100 58 -70 c202 -244 221 -557 50
-817 -62 -94 -150 -171 -258 -224 -138 -68 -282 -90 -418 -63 -46 10 -70 8
-144 -7 -58 -12 -134 -18 -220 -18 -73 -1 -133 -2 -133 -3 0 -11 146 -106 215
-139 145 -71 223 -87 405 -87 140 0 164 2 243 26 167 51 303 134 418 253 110
116 177 232 225 389 25 82 27 104 27 245 0 182 -16 260 -87 405 -95 198 -248
347 -450 441 -92 42 -176 63 -306 78 l-105 12 70 57 c145 120 301 173 480 164
178 -10 304 -66 436 -197 149 -147 208 -302 195 -514 -4 -61 -8 -122 -8 -136
-1 -14 7 -71 16 -128 12 -67 17 -138 14 -206 -4 -122 -4 -122 77 -2 65 96 117
221 141 336 24 122 16 314 -20 433 -100 335 -365 578 -706 649 -131 28 -307
21 -433 -16 -384 -113 -651 -448 -669 -838 -2 -38 -5 -68 -8 -68 -13 0 -90 89
-122 140 -234 373 -62 852 359 1001 72 26 269 37 337 20 36 -9 58 -8 113 6 47
11 116 16 220 17 84 1 153 3 153 6 0 9 -110 85 -177 122 -72 40 -182 79 -271
97 -73 15 -274 12 -351 -4z m290 -1230 c64 -42 99 -132 79 -204 -50 -187 -317
-189 -365 -3 -24 92 13 174 98 217 64 33 130 29 188 -10z"/>
            </g>
        </svg>
    );
}

// User icon component
function UserIcon() {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        >
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
        </svg>
    );
}

// Header for About page
function AboutHeader({ isAuthenticated, userData }) {
    const nav = useNavigate();
    const isDoctor = isUserDoctor(userData);
    const isClient = isUserClient(userData);

    const handleProfileClick = () => {
        nav(ROUTES.PROFILE, { viewTransition: true });
    };

    // Logo always links to home page
    const getHomeRoute = () => ROUTES.HOME;

    return (
        <header className="about-header">
            <div className="about-header-container">
                <Link to={getHomeRoute()} className="about-header-logo" viewTransition>
                    <div className="about-header-logo-icon">
                        <LogoIcon />
                    </div>
                    <span className="about-header-logo-text">Spiria</span>
                </Link>
                
                <nav className="about-header-nav">
                    {isAuthenticated ? (
                        <button 
                            className="about-header-profile-btn"
                            onClick={handleProfileClick}
                        >
                            <UserIcon />
                            <span>Профиль</span>
                        </button>
                    ) : (
                        <Link to={ROUTES.AUTH} className="about-header-login-btn" viewTransition>
                            Войти
                        </Link>
                    )}
                </nav>
            </div>
        </header>
    );
}

function AboutPage() {
    const nav = useNavigate();
    const { data: userData } = useUser();
    const isAuthenticated = !!(userData && (isUserDoctor(userData) || isUserClient(userData)));

    const handleBack = () => {
        nav(-1);
    };

    // Schema.org structured data для AboutPage
    const aboutPageSchema = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "О платформе Spiria",
        "description": "Узнайте больше о платформе Spiria — нашей истории, миссии и команде",
        "url": window.location.origin + "/about",
        "inLanguage": "ru",
        "isPartOf": {
            "@type": "WebSite",
            "name": "Spiria",
            "url": window.location.origin
        },
        "about": {
            "@type": "Organization",
            "name": "Spiria",
            "description": "Платформа для управления здоровьем и медицинских опросников",
            "foundingDate": "2023",
            "founders": [
                {
                    "@type": "Person",
                    "name": "Иван Ермолов"
                }
            ],
            "areaServed": "RU",
            "knowsAbout": ["Здравоохранение", "Медицинские технологии", "Телемедицина", "Медицинские опросники"]
        }
    };

    return (
        <>
            <SEO 
                title="О платформе" 
                description="Узнайте больше о Spiria — нашей истории, миссии и команде. Цифровая платформа для управления здоровьем, созданная с заботой о пациентах и врачах."
                keywords="о нас, spiria, команда, миссия, здравоохранение, медицинская платформа"
                structuredData={aboutPageSchema}
            />
            <AboutHeader isAuthenticated={isAuthenticated} userData={userData} />
            <div className="about-page">
                {/* Back Button */}
                <div className="about-back-container">
                    <button className="about-back-btn" onClick={handleBack}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M19 12H5M12 19l-7-7 7-7"/>
                        </svg>
                        Назад
                    </button>
                </div>
                {/* Hero Section */}
                <section className="about-hero">
                    <div className="about-container">
                        <h1 className="about-hero-title">Наша история</h1>
                        <p className="about-hero-subtitle">
                            Цифровая платформа для управления здоровьем, 
                            созданная с заботой о пациентах и врачах
                        </p>
                    </div>
                </section>

                {/* Stats Section */}
                <section className="about-stats">
                    <div className="about-container">
                        <h2 className="about-section-title">Наши достижения</h2>
                        <p className="about-section-subtitle">
                            За годы работы мы создали уникальные решения для множества клиентов 
                            в различных секторах здравоохранения.
                        </p>
                        <div className="about-stats-grid">
                            <div className="about-stat-item">
                                <span className="about-stat-number">1000+</span>
                                <span className="about-stat-label">Пациентов</span>
                            </div>
                            <div className="about-stat-item">
                                <span className="about-stat-number">500+</span>
                                <span className="about-stat-label">Медицинских опросов</span>
                            </div>
                            <div className="about-stat-item">
                                <span className="about-stat-number">50+</span>
                                <span className="about-stat-label">Врачей-коллег</span>
                            </div>
                            <div className="about-stat-item">
                                <span className="about-stat-number">99%</span>
                                <span className="about-stat-label">Довольных пользователей</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Story Section */}
                <section className="about-story">
                    <div className="about-container">
                        <div className="about-story-content">
                            <div className="about-story-text">
                                <h2 className="about-section-title">Как всё начиналось</h2>
                                <p>
                                    Spiria начала свой путь в 2023 году, когда группа энтузиастов 
                                    здравоохранения и IT-специалистов объединилась общей идеей — 
                                    сделать управление здоровьем доступным и удобным для каждого.
                                </p>
                                <p>
                                    Начиная с небольшого стартапа, мы выросли в полноценную 
                                    платформу, которая помогает пациентам следить за своим здоровьем, 
                                    а врачам — эффективно управлять пациентами и их лечением.
                                </p>
                                <p>
                                    Мы остаёмся верны нашим изначальным ценностям: 
                                    забота о людях, инновации и стремление к excellence 
                                    в каждой функции платформы.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Milestones Section */}
                <section className="about-milestones">
                    <div className="about-container">
                        <h2 className="about-section-title">Ключевые вехи</h2>
                        <div className="about-timeline">
                            <div className="about-timeline-item">
                                <div className="about-timeline-year">2023</div>
                                <div className="about-timeline-content">
                                    <h3>Основание Spiria</h3>
                                    <p>Уфа</p>
                                </div>
                            </div>
                            <div className="about-timeline-item">
                                <div className="about-timeline-year">2024</div>
                                <div className="about-timeline-content">
                                    <h3>Первые 100 пациентов</h3>
                                    <p>Регионы России</p>
                                </div>
                            </div>
                            <div className="about-timeline-item">
                                <div className="about-timeline-year">2025</div>
                                <div className="about-timeline-content">
                                    <h3>Запуск мобильного приложения</h3>
                                    <p>iOS и Android</p>
                                </div>
                            </div>
                            <div className="about-timeline-item about-timeline-future">
                                <div className="about-timeline-year">2026</div>
                                <div className="about-timeline-content">
                                    <h3>Лучшее ещё впереди</h3>
                                    <p>Ждём новых достижений вместе</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Mission Section */}
                <section className="about-mission">
                    <div className="about-container">
                        <div className="about-mission-content">
                            <div className="about-mission-text">
                                <h2 className="about-section-title">Почему мы это делаем</h2>
                                <p>
                                    В современном стремительно меняющемся цифровом ландшафте 
                                    бизнес сталкивается со сложными вызовами, требующими 
                                    инновационных решений.
                                </p>
                                <p>
                                    Мы в Spiria верим, что современные технологии — это ключ 
                                    к преодолению этих препятствий. Создавая цифровые продукты, 
                                    адаптированные под конкретные потребности здравоохранения, 
                                    мы упрощаем сложные процессы и способствуем устойчивому росту.
                                </p>
                                <p>
                                    Наша приверженность сотрудничеству гарантирует, что мы 
                                    глубоко погружаемся в истории наших клиентов и работаем 
                                    вместе, чтобы создавать ощутимые изменения.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Team Section */}
                <section className="about-team">
                    <div className="about-container">
                        <h2 className="about-section-title">Наша команда</h2>
                        <p className="about-section-subtitle">
                            Опытная команда, обеспечивающая выдающийся опыт 
                            как для клиентов, так и для сотрудников.
                        </p>
                        <div className="about-team-grid">
                            <div className="about-team-member">
                                <img className="about-team-avatar" src={Ivan}></img>
                                <h3 className="about-team-name">Иван Ермолов</h3>
                                <p className="about-team-role">Project Manager & Lead Backend</p>
                            </div>
                            <div className="about-team-member">
                                <img className="about-team-avatar" src={Danila}></img>
                                <h3 className="about-team-name">Данила Янчиев</h3>
                                <p className="about-team-role">Backend Developer & QA</p>
                            </div>
                            <div className="about-team-member">
                                <img className="about-team-avatar" src={Ruslan}></img>
                                <h3 className="about-team-name">Руслан Агафонов</h3>
                                <p className="about-team-role">Frontend Developer</p>
                            </div>
                            <div className="about-team-member">
                                <img className="about-team-avatar" src={Senya}></img>
                                <h3 className="about-team-name">Арсений Макаркин</h3>
                                <p className="about-team-role">Android Developer</p>
                            </div>
                            <div className="about-team-member">
                                <img className="about-team-avatar" src={Aydar}></img>
                                <h3 className="about-team-name">Айдар Шакирзянов</h3>
                                <p className="about-team-role">Product Manager & Business Development</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Values Section */}
                <section className="about-values">
                    <div className="about-container">
                        <h2 className="about-section-title">Наши ценности</h2>
                        <div className="about-values-grid">
                            <div className="about-value-card">
                                <div className="about-value-icon">💙</div>
                                <h3>Забота о пациентах</h3>
                                <p>Каждое решение принимается с мыслью о том, как оно повлияет на здоровье и комфорт наших пользователей.</p>
                            </div>
                            <div className="about-value-card">
                                <div className="about-value-icon">🔒</div>
                                <h3>Безопасность данных</h3>
                                <p>Мы используем передовые технологии шифрования для защиты медицинской информации наших пользователей.</p>
                            </div>
                            <div className="about-value-card">
                                <div className="about-value-icon">🚀</div>
                                <h3>Инновации</h3>
                                <p>Постоянно исследуем новые технологии, чтобы предлагать самые современные решения в здравоохранении.</p>
                            </div>
                            <div className="about-value-card">
                                <div className="about-value-icon">🤝</div>
                                <h3>Партнёрство</h3>
                                <p>Строим долгосрочные отношения с врачами и клиниками, работая как одна команда.</p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="about-cta">
                    <div className="about-container">
                        <h2 className="about-cta-title">Присоединяйтесь к нам</h2>
                        <p className="about-cta-text">
                            Хотите стать частью команды, которая меняет здравоохранение к лучшему?
                            Или хотите узнать больше о наших решениях?
                        </p>
                        <div className="about-cta-buttons">
                            <a href="mailto:info@spiria.ru" className="about-cta-button about-cta-button-primary">
                                Связаться с нами
                            </a>
                            <a href="/team_pres.pdf" target="_blank" rel="noopener noreferrer" className="about-cta-button about-cta-button-secondary">
                                Презентация компании
                            </a>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default AboutPage;
